import React from 'react';
import { Layout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';

export type LayoutHeaderProps = LayoutProps;

const ProLayoutHeader: React.FC<LayoutHeaderProps> = React.forwardRef<
  any,
  LayoutHeaderProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return (
    <Layout.Header ref={ref} {...resProps}>
      {children}
    </Layout.Header>
  );
});

export default ProLayoutHeader;
